import PropTypes from 'prop-types';

/**
 * @memberof module:react/propTypes
 * @typedef {Object} DeliveryFeed
 * @prop {number} id Feed id
 * @prop {number} partnerId Partner id
 * @prop {number} axisId Axis Id
 * @prop {number} service Feed service
 * @prop {number} assetType Type of the assetType
 * @prop {number} assetTitle Title of the asset
 * @prop {number} status status
 * @prop {number} displayId Display id
 * @prop {number} axisUrl Url for the axis order
 * @prop {number} date Date fulfilled
 * @prop {number} previewUrl Path to the preview
 */
export default PropTypes.shape({
  id: PropTypes.number,
  partnerId: PropTypes.string,
  axisId: PropTypes.string,
  service: PropTypes.string,
  assetType: PropTypes.string,
  assetTitle: PropTypes.string,
  status: PropTypes.string,
  displayId: PropTypes.string,
  axisUrl: PropTypes.string,
  date: PropTypes.string,
  previewUrl: PropTypes.string
});



// WEBPACK FOOTER //
// ./app/propTypes/axisDeliveryFeed.js